import { ThemeOptions, createTheme } from '@material-ui/core';
import { PaletteOptions } from '@material-ui/core/styles/createPalette';
import { Spacing } from '@material-ui/core/styles/createSpacing';

const defaultTheme = createTheme();

export const themeColors = {
    error: '#ff4f4c',
    info: '#2e69f0',
    neutral: '#323232',
    primary: '#6b30fa',
    secondary: '#ff78d6',
    success: '#08696b',
    textPrimary: 'rgba(0, 0, 0, 0.94)',
    textSecondary: 'rgba(0, 0, 0, 0.54)',
    warning: '#f5cf47',
};

export const themeBackgroundColors = {
    error: '#d9534f',
    info: '#eaf0fd',
    neutral: '#f1f1f1',
    primary: '#f0eafe',
    secondary: '#fff1fa',
    success: '#e6f0f0',
    warning: '#fefaec',
};

export const LightThemeContextBackgrounds = {
    ...themeBackgroundColors,
};

export const LightThemePalette: PaletteOptions = {
    contextBackgrounds: LightThemeContextBackgrounds,
    error: {
        main: themeColors.error,
    },
    info: {
        main: themeColors.info,
    },
    neutral: {
        main: themeColors.neutral,
    },
    primary: {
        main: themeColors.primary,
    },
    secondary: {
        main: themeColors.secondary,
    },
    success: {
        main: themeColors.success,
    },
    type: 'light',
    warning: {
        main: themeColors.warning,
    },
};

export const spacing: Spacing = defaultTheme.spacing;

export const LightThemeOptions: ThemeOptions = {
    overrides: {
        MuiButton: {
            outlined: {
                padding: '7px 23px',
            },
            root: {
                borderRadius: '360px',
                fontSize: '1rem',
                fontWeight: 700,
                letterSpacing: '0.46px',
                padding: '8px 24px',
            },
            text: {
                padding: '8px 24px',
            },
        },
        MuiInputBase: {
            input: {
                fontSize: '1.1rem',
            },
        },
        MuiInputLabel: {
            root: {
                fontSize: '1.1rem',
                lineHeight: '1.1rem',
            },
        },
        MuiListItem: {
            button: {
                '&$selected': {
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            },
            root: {
                '&$selected': {
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    backgroundColor: 'transparent',
                    fontWeight: 700,
                },
                '&:hover': {
                    backgroundColor: 'transparent',
                },
                padding: 0,
                paddingBottom: 0,
                paddingTop: 0,
            },
        },
        MuiListItemIcon: {
            root: {
                fontSize: '16px',
                padding: '13px',
            },
        },
        MuiListItemText: {
            root: {
                fontSize: '1rem',
                fontWeight: 400,
            },
        },
        MuiListSubheader: {
            root: {
                fontSize: '1rem',
                fontWeight: 600,
            },
        },
        MuiSvgIcon: {
            root: {
                fontSize: '1.5rem',
            },
        },
        MuiTableCell: {
            root: {
                borderBottom: 'none',
                padding: '13px',
            },
        },
        MuiTableHead: {
            root: {
                '& > tr': {
                    '& > th,td': {
                        padding: '9px',
                    },
                    borderBottom: `1px solid ${themeColors.primary}`,
                },
            },
        },
        MuiTableRow: {
            root: {
                '& > th': {
                    fontWeight: 700,
                },
            },
        },
    },
    palette: {
        ...LightThemePalette,
        text: {
            primary: '#000000',
        },
    },
    props: {
        MuiButton: {
            disableElevation: true,
            disableRipple: true,
            variant: 'contained',
        },
        MuiButtonBase: {
            disableRipple: true,
        },
        MuiCheckbox: {
            color: 'primary',
        },
        MuiRadio: {
            color: 'primary',
        },
        MuiSwitch: {
            color: 'primary',
            disableRipple: true,
        },
    },
    typography: {
        button: {
            fontFamily: ['Space Mono', 'sans-serif'].join(','),
            textTransform: 'none',
        },
        fontFamily: ['GalanoGrotesque', 'Poppins', 'sans-serif'].join(','),
        fontSize: 14,
        h2: {
            fontSize: '2.28rem',
            fontWeight: 600,
        },
        h3: {
            fontSize: '1.70rem',
            fontWeight: 600,
        },
        h4: {
            fontWeight: 600,
        },
        htmlFontSize: 14,
        subtitle1: {
            fontWeight: 600,
        },
        subtitle2: {
            fontWeight: 600,
        },
    },
};

export const LightTheme = createTheme(LightThemeOptions);
